// @vendor
const React = require('react');
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @actions
const ecommerceCheckKeyActions = require('actions/getEcommerceKey');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKLink } = require('commonsComponents/OKLink');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;

// @components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const EcommerceKeyShowOrHide = require('./myProfileEcommerceKeyShowOrHide/myProfileEcommerceKeyShowOrHide');
const EcommerceKeyCheckError = require('./myProfileEcommerceCheckError/myProfileEcommerceCheckError');
require('./myProfileEcommerceKeyCheckView.scss');

// @ constants
const infoIcon = require('assets/images/icon-info-blue.svg');
const { ECOMMERCE_REQUEST_ID } = require('constants/operationTypes');

class MyProfileEcommerceKeyCheckView extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        const { resetEcommerceKey } = this.props;
        resetEcommerceKey();
    }

    handleSubmit = () => {
        const { requestKey } = this.props;
        requestKey();
    }

    isReady = () => {
        return false;
    }

    buildInfoEcommerce() {
        const { setKeyExpired, resetEcommerceKey, immEcommerceKey } = this.props;

        let block;
        let sectionContent;

        if (immEcommerceKey) {
            const codeSuccess = immEcommerceKey.get('success');
            const hasError = !!immEcommerceKey.get('error');
            const eCommerceKey = immEcommerceKey.get('challenge');

            if (codeSuccess) {
                sectionContent = (
                    <div className="my-profile-ecommerce-key-info__info-text--check">
                        <OKBoxTitle value={formatText('eCommerceKeyCheck-secondTitle')} />
                        <div className="my-profile-ecommerce-key-info__info-text--check">
                            <FormattedText value={`eCommerceKeyCheck-infoTextEcommerce`} />
                        </div>             
                        <div className="my-profile-ecommerce-key-info__section-container">
                            <div className="my-profile-ecommerce-key-info__section-container__title">
                                <FormattedText value={`eCommerceKeyCheck-titleSectionEcommerce`} />
                            </div> 
                        </div>
                        <EcommerceKeyShowOrHide
                            ecommerceKey={eCommerceKey}
                            reset={resetEcommerceKey}
                            setExpired={setKeyExpired}
                            title={formatText(`eCommerceKeyCheck-successTitle`)}
                            textBack={formatText(`eCommerceKeyCheck-backToEcommerceKey`)}
                            textNewRequest={formatText(`eCommerceKeyCheck-newRequest`)}
                            messageShortNonExpired={formatText(`eCommerceKeyCheck-shortNonExpiredMessage`)}
                            messageExpired={formatText(`eCommerceKeyCheck-expiredMessage`)}
                            newRequestText={formatText(`eCommercekeyCheck-newRequestText`)}
                        />
                    </div>
                )
            }
            else if (hasError) {
                sectionContent = (
                    <div className="my-profile-ecommerce-key-info__info-text--check">
                        <EcommerceKeyCheckError />
                    </div>
                )
            }
            else {
                const linkToEcommerceLanding = `/myprofile/keys/ecommerce`;
                const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
                const cancelText = formatText('wizard-redirectConfirmationCancelButton');
                const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
                const confirmationMessage = formatText('wizard-redirectConfirmationMessage');

                sectionContent = (
                    <div className="my-profile-ecommerce-key-info__info-text--check">
                        <OKBoxTitle value={formatText('eCommerceKeyCheck-secondTitle')} />
                        <div className="my-profile-ecommerce-key-info__info-text--check">
                            <FormattedText value={`eCommerceKeyCheck-infoTextEcommerce`} />
                        </div>   
                        <div className="my-profile-ecommerce-key-info__section-container">
                            <div className="my-profile-ecommerce-key-info__section-container__title">
                                <FormattedText value={`eCommerceKeyCheck-confirmationTitle`} />
                            </div>
                        </div>
                        <article>
                            <div className="ecommerce-key-request-view__otp-container">
                                <SignaturePattern
                                    operationType={ECOMMERCE_REQUEST_ID}
                                    operationParams={{}}
                                />
                            </div>
                            <footer className="ecommerce-key-request-view__footer-otp">
                                <div className="ecommerce-key-request-view__cancel-button">
                                    <OKLink
                                        modifier="inherit-styles"
                                        to={linkToEcommerceLanding}
                                    >
                                        <FormattedText value={`eCommerceKeyRequest-cancel`} />
                                    </OKLink>
                                </div>
                                <SignaturePatternButton
                                    onClick={this.handleSubmit}
                                >
                                    <FormattedText value={`eCommerceKeyRequest-request`} />
                                </SignaturePatternButton>
                            </footer>
                            <PreLeaveModalComponent
                                confirmationMessage={confirmationMessage}
                                confirmationTitle={confirmationTitle}
                                acceptText={acceptText}
                                cancelText={cancelText}
                                isReady={this.isReady}
                            />
                        </article>
                    </div>   
                )
            }

            block = (
                <div className="row">
                    <div className="col-md-12">
                        <ContentBox>
                            <div className="my-profile-ecommerce-key-info row">
                                <div className="col-xs-12">
                                    {sectionContent}
                                </div>
                            </div>
                        </ContentBox>
                    </div>  
                </div>
            );
        } else {
            block = ( 
                <div className="row">
                    <div className="col-md-12">
                        <ContentBox>
                            <div className="my-profile-ecommerce-key-info row">
                                <div className="col-xs-12">
                                    <LoadingSection /> 
                                </div>
                            </div>
                        </ContentBox>
                    </div>  
                </div>
            );
        }
        return block;
    }

    buildContent() {
        const boxBody = (
            <React.Fragment>
                <div className="keys-view__info-icon">
                    <OKIconIllustrative icon="info" product="banking" />
                </div>
                <FormattedText
                    className="contact-info-box__list-item-value"
                    value="eCommerceKeyCheck-boxBody1"
                />
            </React.Fragment>
        )
        const eCommerceInfoContent = this.buildInfoEcommerce();
        return (
            <React.Fragment>
                <div className="col-xs-12 col-md-8">
                    {eCommerceInfoContent}
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-12 grid-view--variable-cell-separation">
                            <ContactInfoBox
                                boxTitle={formatText('eCommerceKeyCheck-boxTitle')}
                                boxBody={boxBody}
                                icon={infoIcon}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    render() {
        const content = this.buildContent();
        const mappingBreadcrumb = [
            {
                text: formatText('profileKeysLanding-title'),
                url: '/myprofile/keys'
            },
            {
                text: formatText('eCommerceKeyLanding-title'),
                url: '/myprofile/keys/ecommerce'
            },  
            {
                text: formatText('eCommerceKeyCheck-titleBreadcrumb'),
                url: ''
            }  
        ];

        return (
            <React.Fragment>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="large" section="accounts" customClass="col-xs-12">
                            <OKHeaderSubPage
                                titleWrap={true}
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('eCommerceKeyCheck-title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

MyProfileEcommerceKeyCheckView.propTypes = {
    immEcommerceKey: PropTypes.object,
    requestKey: PropTypes.func.isRequired,
    resetEcommerceKey: PropTypes.func.isRequired,
    routes: PropTypes.array,
    setKeyExpired: PropTypes.func.isRequired
};

module.exports.constructor = MyProfileEcommerceKeyCheckView;
module.exports.MyProfileEcommerceKeyCheckView = connect(
    state => ({
        immEcommerceKey: state.ecommerceKeyRequest,
    }), {
        requestKey: ecommerceCheckKeyActions.requestKey,
        resetEcommerceKey: ecommerceCheckKeyActions.resetEcommerceKey,
        setKeyExpired: ecommerceCheckKeyActions.setExpired
    })(MyProfileEcommerceKeyCheckView);